import axios from 'axios'
import config from '../config/dev.json'
import Vue from 'vue'

let path = '/api/v1'
let url = config.host + path + '/conversation'
let url1 = config.host + path + '/secure/expression'

let urlNLP = config.hostnlp
let urlUp = config.host + path + '/file'


import production from '../config/production.json'
import {
  refresh
} from './auth.service.js';
if (process.env.NODE_ENV === 'production') {
  url = production.host + path + '/conversation'
  url1 = production.host + path + '/secure/expression'

}


export async function addExpression(expression) {
  return new Promise((resolve, reject) => {
    axios.post(url1 + '/add', expression).then((response) => {
      let newExpression = response.data.data
      resolve(newExpression)
    }).catch(err => reject(err))
  })
}

export async function getConversationById(id) {
  return new Promise((resolve, reject) => {
    axios.get(url + '/get/' + id).then((response) => {
      let conversation = response.data.data
      resolve(conversation)
    }).catch(err => {
      if (err.response.status === 401) {
        refresh().then(() => {
          resolve(getConversation(id))
        }).catch(err => reject(err))
      }
    })
  })
}
export async function removeFile(obj) {
  return new Promise((resolve, reject) => {
    let propsData = {
      duration: 1500,
      direction: "right",
    }
    axios.post(urlUp + '/remove/file/', obj).then((response) => {
     
      resolve(response.data.data)
    }).catch(err => {

    })
  })
}
export async function resultsfile(idbot) {
  return new Promise((resolve, reject) => {

    axios.get(url + '/api/files/getall/' + idbot).then((response) => {
      // response.data.forEach(element => {
      // });
      resolve(response.data.data)
    }).catch(err => {
    })
  })
}

// export async function uploadffile(formData, idbot,switche, domaine) {
//   return new Promise((resolve, reject) => {
//     let propsData = {
//       duration: 1500,
//       direction: "right",
//     }
//       axios.post(urlUp + '/upload/batch/' + idbot +'/'+switche+'/'+domaine, formData, {timeout: 600000}).then((respse) => {
//         // axios({
//         //   method: 'post',
//         //   url:urlUp + '/upload/batch/' + idbot +'/'+switche+'/'+domaine,
//         //   timeout: 600000, // Let's say you want to wait at least 6 mins
//         //   data:  formData,
          
//         // }).then((respse) => {
//         resolve(respse.data.data)
//       }).catch(err => {
    
//   })
// }

export async function uploadffile(formData, idbot,switche, domaine, typeUser) {
  return new Promise((resolve, reject) => {
    let propsData = {
      duration: 1500,
      direction: "right",
    }
      axios.post(urlUp + '/upload/batch/' + idbot +'/'+switche+'/'+domaine+'/'+typeUser, formData, {timeout: 600000}).then((respse) => {
        // axios({
        //   method: 'post',
        //   url:urlUp + '/upload/batch/' + idbot +'/'+switche+'/'+domaine,
        //   timeout: 600000, // Let's say you want to wait at least 6 mins
        //   data:  formData,
          
        // }).then((respse) => {
        resolve(respse.data.data)
      }).catch(err => {
            })
    
  })
}
// upload nrmlm tkoun fi upload file // serviceuploadfile intent
export async function uploadFileExcel(formData, id) {
  return new Promise((resolve, reject) => {
    axios.post(urlUp + '/upload/' + id, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then((response) => {
      //  location.reload()
      resolve(response.data.data)
    })
  })
}

export async function uploadImage(formData, id) {
  return new Promise((resolve, reject) => {
    axios.post(urlUp + '/image/' + id, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then((response) => {
      resolve(response.data.data)
    })
  })
}

export async function getAllConversationbyBot(id) {
  return new Promise((resolve, reject) => {

    axios.get(url + '/bot/get/' + id).then((response) => {
      let conversation = response.data.data

      resolve(conversation)
    }).catch(err => {
      if (err.response.status === 401) {
        refresh().then(() => {
          resolve(getAllConversationbyBot())
        }).catch(err => reject(err))
      }
    })
  })
}



export async function getConversationAll() {
  return new Promise((resolve, reject) => {
    axios.get(url + '/get/all').then((response) => {
      let conversations = response.data.data
      resolve(conversations)
    }).catch(err => {
      if (err.response.status === 401) {
        refresh().then(() => {
          resolve(getConversationAll())
        }).catch(err => reject(err))
      }
    })
  })
}

export async function getMessageConversation(id) {
  return new Promise((resolve, reject) => {
    axios.get(url + '/get/' + id + '/message').then((response) => {
      let messages = response.data.data
      resolve(messages)
    }).catch(err => {
      if (err.response.status === 401) {
        refresh().then(() => {
          resolve(getMessageConversation(id))
        }).catch(err => reject(err))
      }
    })
  })
}

function guidUtt() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

export async function getuttrnaceAll(idBot) {
  return new Promise((resolve, reject) => {

    axios.get(url + '/get/' + idBot + '/all/messages').then((response) => {

      let messages = response.data.data
      resolve(messages)
    }).catch(err => {
      if (err.response.status === 401) {
        refresh().then(() => {
          resolve(getuttrnaceAll(idBot))
        }).catch(err => reject(err))
      }
    })
  })
}





export async function addConversation(conv) {
  return new Promise((resolve, reject) => {
    let obj = {
      bot: {
        name: '',
        _id: '',
        switche:'',
      },
      participants: {
        participantId: '',
        username: '',
        typeUser:""
      },
     
      str: ''
    }
    obj.str = conv.messages.text
    obj.bot.name = conv.nameBot
    obj.bot._id = conv.botId
    obj.bot.switche = conv.switche
    obj.bot.domaine = conv.domaine

     obj.typeUser = conv.typeUser
    obj.participants.participantId = conv.participantId
    obj.participants.username = conv.partciusername
    let listUtee = []
    let objj = {}
    // intt : "",
    // utt : ""
    //}
      let entit = {
        entity : "",
        entity_type:""
      }
    axios.post(urlNLP + '/nlp', obj, {
      headers: {
        'Content-type': 'application/JSON'
      }
    }).then((respse) => {
      let resp = respse.data

      if (resp === "Merci de cliquer d'abord sur Train") {
        resolve(respse.data)
      } else if (resp && resp.length && resp.length > 1) {
        resp.forEach((element, index) => {

          objj = {
            intents: element.intent,
            utterances: element.utterance,
            DateEnv: Date.now(),
            score: element.score,
            language: element.sentiment.language,
            uid: guidUtt()
          
          }


          listUtee.push(objj)


          conv.messages.utterance = listUtee

          element.entities.forEach(le => {
            conv.messages.entities.push(le.entity)
          })
          if (resp.length == (index + 1)) {
            axios.post(url + '/add', conv).then((response) => {

              let newConver = response.data.data
              newConver.response = resp
              resolve(newConver)
            })
          }
        });
      } else {
        conv.messages.utterance.forEach(element => {
          element.intents = resp[0].intent
          element.utterances = resp[0].utterance
          element.DateEnv = Date.now(),
         
            element.nature = "application"
          element.language = resp[0].sentiment.language
          element.score = resp[0].score
         
        });
            let listen = []
        if ((resp[0].entities).length > 0) {
          resp[0].entities.forEach((eleme, ind) => {
            if(typeof eleme['entity type'] == 'undefined'){
              entit = {
                entity : eleme.entity,
                entity_type:"app"
              }
             // entit.entity = eleme.entity
            //  entit.entity_type = eleme['entity type']
              listen.push(entit)
            } else {
              entit = {
                entity : eleme.entity,
                entity_type:eleme['entity type']
              }
             // entit.entity = eleme.entity
            //  entit.entity_type = eleme['entity type']
              listen.push(entit)
            }
            
              if(ind +1 ==(resp[0].entities).length){
                 conv.messages.entities = listen
              }
          })
        //  conv.messages.entities = resp[0].entities[0].entity

        } else {
          conv.messages.entities = "None"
        }

        axios.post(url + '/add', conv).then((response) => {

          let newConver = response.data.data
          newConver.response = resp[0]
          resolve(newConver)
        }).catch(err => {
          if (err.response.status === 401) {
            refresh().then(() => {
              resolve(addConversation(conv))
            }).catch(err => reject(err))
          }
        })
      }
    })
  })
}

export async function addMessage(conv) {
  return new Promise((resolve, reject) => {
    let obj = {
      bot: {
        name: '',
        _id: '',
        switche:''
      },
      str: '',
      
    }
    let entit = {
      entity : "",
      entity_type:""
    }
    let listUtee = []
    let objj = {}
    obj.str = conv.messages.text
    obj.bot.name = conv.nameBot
    obj.bot._id = conv.botId
    obj.bot.switche = conv.switche
    obj.typeUser = conv.typeUser
    obj.domaine = conv.domaine
    axios.post(urlNLP + '/nlp', obj, {
      headers: {
        'Content-type': 'application/JSON'
      }
    }).then((respse) => {
      let resp = respse.data
      if (resp && resp.length && resp.length > 1) {
        conv.messages.intents = []
        resp.forEach((element, index) => {
        
          objj = {
            intents: element.intent,
            utterances: element.utterance,
            DateEnv: Date.now(),
            score: element.score,
            language: element.sentiment.language,
            uid: guidUtt()
          }


          listUtee.push(objj)


          conv.messages.utterance = listUtee

          element.entities.forEach(le => {
            conv.messages.entities.push(le.entity)
          })

          if (resp.length == (index + 1)) {
            axios.post(url + '/' + conv._id + '/add/message', conv).then((response) => {
              let newConver = response.data.data
              newConver.response = resp
              resolve(newConver)
            })
          }
        });
      } else {
        let listen = []
        if ((resp[0].entities).length > 0) {
          resp[0].entities.forEach((eleme, ind) => {
            if(typeof eleme['entity type'] == 'undefined'){
              // entit = {
              //   entity : eleme.entity,
              //   entity_type:"app"
              // }
             entit.entity = eleme.entity
             entit.entity_type = "app"
              listen.push(entit)
            } else {
              // entit = {
              //   entity : eleme.entity,
              //   entity_type:eleme['entity type']
              // }
              entit.entity = eleme.entity
              entit.entity_type = eleme['entity type']
              listen.push(entit)
            }
            
              if(ind +1 ==(resp[0].entities).length){
                 conv.messages.entities = listen
              }
          })
        //  conv.messages.entities = resp[0].entities[0].entity

        } else {
          conv.messages.entities = "None"
        }


        conv.messages.language = resp[0].sentiment.language
        conv.messages.utterance.forEach(element => {
          element.intents = resp[0].intent
          element.utterances = resp[0].utterance
          element.DateEnv = Date.now(),
            element.language = resp[0].sentiment.language
          element.score = resp[0].score
        });

        axios.post(url + '/' + conv._id + '/add/message', conv).then((response) => {

          let updateConver = response.data.data
          updateConver.response = resp[0]
          resolve(updateConver)
        }).catch(err => {
          if (err.response.status === 401) {
            refresh().then(() => {
              resolve(addMessage(conv))
            }).catch(err => reject(err))
          }
        })
      }
    })
  })
}



export async function removeConversation(id) {
  return new Promise((resolve, reject) => {
    axios.delete(url + '/remove/' + id).then((response) => {
      resolve(response)
    }).catch(err => {
      if (err.response.status === 401) {
        refresh().then(() => {
          resolve(removeConversation(id))
        }).catch(err => reject(err))
      }
    })
  })
}

export async function removeMessages(ids) {
  return new Promise((resolve, reject) => {
    axios.post(url + '/remove/messages', ids).then((response) => {
      resolve(response.data.data)
    }).catch(err => {
      if (err.response.status === 401) {
        refresh().then(() => {
          resolve(removeMessages(ids))
        }).catch(err => reject(err))
      }
    })
  })
}

export async function updateMessages(obj) {
  return new Promise((resolve, reject) => {
    axios.post(url + '/update/messagesIntent', obj).then((response) => {
      let updateconv = response.data.data
      resolve(updateconv)
    }).catch(err => {
      if (err.response.status === 401) {
        refresh().then(() => {
          resolve(updateMessages(obj))
        }).catch(err => reject(err))
      }
    })
  })

}


export async function updateConversation(id, conv) {
  return new Promise((resolve, reject) => {
    axios.put(url + '/update/' + id, conv).then((response) => {
      let updateconv = response.data.data
      resolve(updateconv)
    }).catch(err => {
      if (err.response.status === 401) {
        refresh().then(() => {
          resolve(updateConversation(id, conv))
        }).catch(err => reject(err))
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/conversation.service.js